export default __webpack_public_path__ + "static/media/arrow-left-black.004b97ac.svg";